var r="@hpstellar/core/comparebar";export{r as compareBarTestId};
